import * as types from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    isFetching: false,
    entities: null,
    hasMoreDataToLoad: true
};

const requestUserDailySteps = (state) => {
    return {
        ...state,
        isFetching: true
    };
};

const receiveUserDailySteps = (state, action) => {
    let entities = state.entities;

    if (!entities) {
        entities = [];
    }

    entities = [...entities, ...action.data];

    return {
        ...state,
        isFetching: false,
        entities: entities,
        lastUpdated: action.receivedAt,
        hasMoreDataToLoad: action.data.length === 10
    };
};

const resetToInitialState = () => INITIAL_STATE;

const handlers = {
    [types.REQUEST_USER_DAILY_STEPS]: requestUserDailySteps,
    [types.RECEIVE_USER_DAILY_STEPS]: receiveUserDailySteps,
    [types.FAILED_USER_DAILY_STEPS]: receiveUserDailySteps,
    [types.RESET_USER_DAILY_STEPS]: resetToInitialState
};

export const getUserDailySteps = (state) => {
    return state.userDailySteps;
};

export default function userDailySteps(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
